import common from './common-educabot'

export default {
  ...common.button,
  color: `#FFFFFF`,
  '::after': {
    ...common.button['::after'],
    bg: `#2A205E`,
    borderColor: `#2A205E`
  }
}